var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"page-back-btn",attrs:{"icon":"el-icon-back"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default",function(){return [_vm._v("返回列表")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }